module.exports = __webpack_public_path__ + "images/category_lp/smartphone/store_images/1_5277fdea98ecaebb991ba7667690392c.png";